export default __webpack_public_path__ + "static/media/research_01.e0beb492.png";